import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Lock } from 'lucide-react';

const Footer: React.FC = () => (
  <footer className="text-center py-6 text-sm text-gray-400">
    © 2025 LisaServer.com · Todos los derechos reservados · Una marca de AthosFera, LLC
  </footer>
);

const ClientLogin: React.FC = () => {
  const { clientHash } = useParams<{ clientHash: string }>();
  const { login } = useAuth();
  // El 'navigate' ya no es necesario
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!clientHash) {
      setError('URL de cliente no válida.');
      setLoading(false);
      return;
    }

    const success = await login(credentials.username, credentials.password, clientHash);
    
    if (success) {
      // [CORRECCIÓN DEFINITIVA] En lugar de 'navigate', forzamos una recarga a la nueva URL.
      window.location.href = `/client/${clientHash}/panel`;
    } else {
      setError('Usuario o contraseña incorrectos.');
      setLoading(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex flex-col justify-between p-6">
      <div className="flex-1 flex items-center justify-center">
        <div className="bg-slate-900/50 backdrop-blur-lg rounded-2xl p-8 w-full max-w-md border border-slate-700 shadow-2xl">
          <div className="text-center mb-8">
            <img src="/logo-lisa-5.png" alt="Lisa Server Logo" className="w-auto h-16 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-white mb-2">Acceso de Cliente</h1>
            <p className="text-slate-300">Ingresa tus credenciales</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label htmlFor="username-client" className="block text-sm font-medium text-slate-300 mb-2">Usuario</label>
              <input type="text" id="username-client" value={credentials.username} onChange={(e) => setCredentials({ ...credentials, username: e.target.value })} className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>
            <div>
              <label htmlFor="password-client" className="block text-sm font-medium text-slate-300 mb-2">Contraseña</label>
              <input type="password" id="password-client" value={credentials.password} onChange={(e) => setCredentials({ ...credentials, password: e.target.value })} className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
            </div>
            {error && (<div className="bg-red-500/20 border border-red-500/50 rounded-lg p-3 text-red-200 text-sm">{error}</div>)}
            <button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold py-3 px-4 rounded-lg transition-all flex items-center justify-center">
              {loading ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div> : <><Lock className="h-5 w-5 mr-2" /> Iniciar Sesión</>}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClientLogin;
